export var titanWhite = '#f3f3ff';
export var indigo = '#4f52c3';
export var indigoDark = '#4b5ebd';
export var deepCove = '#08064b';
export var deepCoveDark = '#090a4a';
export var codGrey = '#1A1A1A';
export var white = '#ffffff';
export var black = '#1a1a1a';
export var whiteLilac = '#EDEDF9';
export var alto = '#dedede';
export var silverChalice = "#A5A5A5";
export var mischka = "#DCDCEA";
export var midGray = "#6c6c73";
export var midGrayDark = "#63636a";
export var amber = "#FFC108";
export var royal = "#141975";
export var lightBlueGrey = "#cacad8";
export var tangaroa = "#031148";
export var lightWhite = "#FDFDFD";
export var cadetBlue = "#B2B1C7";
export var lightPurple = "#B746E6";
export var darkOrange = "#FD825D";
export var babyPurple = "#9294F6";
export var lightPurpleTint = "#C2C4FF";
export var lightBlue = "#2284E2";
export var transparentBlack = "#1a1a1ae8";
export var orange = "#EB6D45";
export var blackRock = '#020533';
export var midGrayLight = '#6E6E73';
export var onahau = '#CFE8FF';
export var curiousBlue = '#2284E2';
export var brightSun = '#FFC543';
export var downRiver = '#09264D';
export var persianGreen = '#00B79F';
export var sunGlow = '#FFD324';
export var bitterSweeet = '#FF6A6A';
export var santasGray = '#A2A2AD';
export var hawkesBlue = '#DEDFFC';
export var zircon = '#F5F6FF';
export var magenta = '#B746E6';
export var salmon = '#FF9672';
export var pictonBlue = '#3B98EF';
export var hollywoodCerise = '#D400A1';
export var tuna = '#363639';
export var melrose = '#9D9FFC';
export var burntSienna = '#EB6D45';
export var silverGrey = '#c4c4c4';
export var absentRed = '#E94E4E';
export var dullPurple = '#BCBEFF';
